module.exports = __webpack_public_path__ + "img/index-tjjl3.b3648aa1.png";